function initCarousel() {
    let $featuredStoryScroll = $('.featured-story__carousel-section');

    $featuredStoryScroll.each(function (key, item) {
        if(this.id === '' || this.id === undefined) {
            var sliderIdName = 'featured-story-carousel' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;
            let $slidesToShow = parseInt($(sliderId).attr('data-slidesToShow'));

            $(sliderId).slick({
                dots: false,
                infinite: false,
                speed: 1000,
                slidesToShow: $slidesToShow,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: true,
                mobileFirst: false,
                responsive: [
                    {
                        breakpoint: 1201,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1161,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 481,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    });
}

function setCarouselContentHeight() {
    let featuredStoryCarousels = $('.featured-story');
    featuredStoryCarousels.each(function() {
        const innerElements = $(this).find('.featured-story__carousel-content');
        let maxHeight = 0;
        innerElements.each(function() {
            const height = $(this).height();
            if(height > maxHeight) {
                maxHeight = height;
            }
        });

        innerElements.each(function() {
            $(this).outerHeight(maxHeight);
        });
    });
}

$(function () {
    initCarousel();
    setTimeout(function () {
        setCarouselContentHeight();
    }, 300);

    $(window).resize(function () {
        setTimeout(function () {
            setCarouselContentHeight();
        }, 300);
    });
});
